import  { useState } from 'react';
import './Register.css';
import image2 from '../../assets/image2.png';
// import doodles from '../../assets/doodles.jpg';
import dimg1 from "../../assets/dimg1.svg";
import dimg2 from "../../assets/dimg2.svg";
import dimg3 from "../../assets/dimg3.svg";
import dimg4 from "../../assets/dimg4.svg";
import dimg5 from "../../assets/dimg5.svg";
import { Link } from 'react-router-dom';
import QRimg from "../../assets/QRimg.jpg"
import img1 from "../../assets/img1.png";
import img2 from "../../assets/img2.png";
//  import { FaBeer } from 'react-icons/fa';
import axios from 'axios'
import { Eye, EyeOff } from "lucide-react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";


const Register = () => {
  const [step, setStep] = useState(1);
  const [name, setName] = useState();
  const [phone, setPhone] = useState();
  const [email, setEmail] = useState();
  const [refId, setRefId] = useState();
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [userId, setUserId] = useState();
  const [response, setResponse] = useState('');
  const [shouldAutofill, setShouldAutofill] = useState(false);
   const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    pan: '',
    pan_img: null,
    aadhaar: '',
    bankname: '',
    ifsc: '',
    accountholdername: '',
    accountno: '',
    front: null,
    back: null
  });

  const [tnxData, setTnxData] = useState({
    amount: '',
    mode: '',
    tranx: '',
    file: null
  });



  const handleNext = (e) => {
    e.preventDefault();
    if (step < 5) setStep(step + 1);
  };


  
const submit = async (e) => {
  e.preventDefault();

  if (password !== confirmPassword) {
    setResponse('Passwords do not Match.');
    return;
  }

  const payload = {
    name,
    phone,
    email,
    ref_id: refId,
    password,
  };

  // console.log("Sending data to backend:", payload);

  try {
    const response = await axios.post('https://api.bigfresh.in/signup', payload);
    console.log("Server response:", response.data);

    setUserId(response.data.userId);
    // setResponse('Success! Account Created Successfully.');
       toast.success(" Account Created Successfully", { position: "top-center" });
    setTimeout(() => {
      setResponse('');
      setStep(2);
    }, 2000);
  } catch (error) {
    console.error('Error sending data', error);
   
      toast.error("Something went wrong. Please try again.", { position: "top-center" });
  }
};


  const handleChange = (e) => {
    e.preventDefault();
    const { name, type, files, value } = e.target;

 if (type === "file") {
    const file =  files[0]; 

    if (file) {
      const maxSizeInBytes = 5 * 1024 * 1024; 

      if (file.size > maxSizeInBytes) {
        setResponse("Please select a file smaller than 5MB.");
          e.target.value = null;
        return;
      }

      setResponse("");
      setFormData((prev) => ({ ...prev, [name]: file }));
    }
  } else {
    setFormData((prev) => ({ ...prev, [name]: value }));
  }


  };


  const handleTnxChange = (e) => {
    const { name, value, type, files } = e.target;


  if (type === "file") {
    const file = files[0];

    if (file) {
      const maxSizeInBytes = 5 * 1024 * 1024; 

      if (file.size > maxSizeInBytes) {
    setResponse("Please select a file smaller than 5MB.");
        e.target.value = null; 
        return;
      }

      setResponse(""); 
      setTnxData((prev) => ({
        ...prev,
        [name]: file,
        tranx:
          name === "mode"
            ? value === "cash"
              ? "cash"
              : ""
            : name === "tranx"
            ? value
            : prev.tranx,
      }));
    }
  } else {


     // For non-file inputs
    setTnxData((prev) => ({
      ...prev,
      [name]: value,
      tranx:
        name === "mode"
          ? value === "cash"
            ? "cash"
            : ""
          : name === "tranx"
          ? value
          : prev.tranx,
    }));

      if (name === "amount") {
      const numValue = parseFloat(value);

      if (!isNaN(numValue) && numValue < 7500) {
        setResponse("⚠️ Amount is less than 7500.");
        return; // ❌ stop updating state
      } else {
        setResponse(""); // clear error if valid
      }
    }


   

  }


  };



  const handleSubmit = async (e) => {
    e.preventDefault();

  for (let key in formData) {
  const value = formData[key];
  // console.log(key, value, value instanceof File);

  if (value instanceof File && value.size > 5 * 1024 * 1024) {
    setResponse(`"${value.name}" is larger than 5MB. Please upload a smaller file.`);
    return;
  }
}

    const data = new FormData();

    for (let key in formData) {
      data.append(key, formData[key]);
    }

    try {
      const res = await axios.put(`https://api.bigfresh.in/update-user/${userId}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      // setResponse('Success! Details submitted successfully.');
      toast.success(" Details submitted successfully.", { position: "top-center" });
      setTimeout(() => {
        setResponse('');
        setStep(3)
      }, 2000);


    } catch (error) {
      console.error(error);
      // setResponse('Something went wrong. Try again later.');
       toast.error("Something went wrong. Try again later.", { position: "top-center" });
    }
  };



  const handleDetail = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append('tranx', tnxData.tranx);
    data.append('mode', tnxData.mode);
    data.append('file', tnxData.file);
    data.append('amount', tnxData.amount);
    data.append('trans_type', 'Recharge');


    
    if (tnxData.mode === 'cash') {
      setFormData.trnx = 'cash'
    }

    try {
      const result = await axios.post(`https://api.bigfresh.in/add-trnx/${userId}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      // setResponse('Success! Recharge made to your wallet.');
        toast.success(" Recharge made to your wallet.", { position: "top-center" });
      setTimeout(() => {
        setResponse('');
        setStep(4);
      }, 2000);

      console.log(result);
    } catch (error) {
      console.error(error);
      // setResponse('Something went wrong. Try again later.');
        toast.error("Something went wrong. Try again later.", { position: "top-center" });
      setTimeout(() => {
        setResponse('');
      }, 2000);
    }
  };



  const renderForm = () => {
    switch (step) {
      case 1:
        return (
          <>
            <div className='top-heading'>
              <h3>Create an account</h3>
              {response && <p className='fw-bold'>{response}</p>
              }
            </div>

            <form onSubmit={submit}>
              <input type="text" placeholder="Name*" required className='form-control border-muted'
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <input type="tel" placeholder="Phone No*" required className='form-control border-muted mb-3 py-2'
                value={phone}
                maxLength={10}
                onChange={(e) => setPhone(e.target.value)}
              />
              <input type="email" placeholder="Email Address*" required className='form-control border-muted'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <input type="text" placeholder="Referral Id*" required className='form-control border-muted'
                value={refId}
                onChange={(e) => setRefId(e.target.value.toUpperCase())}
              />


              <input
               type="password" 
              //  type={showPassword ? "text" : "password"}
              placeholder="Enter Password*" required 
              maxLength={8} className='form-control border-muted'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
             

              <input type="password" placeholder="Confirm Password*" required maxLength={8} className='form-control border-muted'
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />

              
              <div style={{display: 'flex', textAlign: 'start'}}>
                <input type='checkbox' style={{width: '1.5em'}} required />
                <label htmlFor='terms' style={{width: '100%', padding: '0em 0.5em', margin: '0.5em 0em', fontSize: '0.9em'}} >
                  Yes, I Understand And Agree To The Terms Of Service
                </label>
              </div>

              <button type='submit' className="create-account-btn" >Create Account</button>
            </form>
          </>
        );

      case 2:
        return (
          <form onSubmit={handleSubmit}>
            <div className='top-heading'>
              {/* <h3>Add PAN & Bank Details</h3> */}
              {response && <p className='fw-bold'>{response}</p>
              }
            </div>

            <p className='fw-bold my-0'>Pan Details</p>
            <div className='d-flex'>
              <input type="text" className='form-control me-2' name="pan" placeholder="PAN No.*" required onChange={handleChange} />
              <input type="file" className='form-control' name="pan_img" accept="image/*,application/pdf" onChange={handleChange} required /></div>

            <p className='fw-bold my-0'>Adhaar Details</p>

            <input type="text" name="aadhaar" placeholder="Aadhar No.*" required onChange={handleChange} />
            <div className='d-flex'>
              <div className='me-2'>
                <p className='my-0 para-text'>Adhaar Front</p>
                <input type="file" className='form-control' name="front" accept="image/*,application/pdf" onChange={handleChange} required /></div>
              <div>
                <p className='my-0 para-text'>Adhaar Back</p>
                <input type="file" className='form-control' name="back" accept="image/*,application/pdf" onChange={handleChange} required /></div>
            </div>
            <p className='fw-bold my-0'>Bank Details</p>
            <input type="text" name="bankname" placeholder="Bank Name*" required onChange={handleChange} />
            <input type="text" name="ifsc" placeholder="IFSC Code*" required onChange={handleChange} />
            <input type="text" name="accountholdername" placeholder="Account Holder Name*" required onChange={handleChange} />
            <input type="text" name="accountno" placeholder="Account Number*" required onChange={handleChange} />

            <button type="submit" className="create-account-btn">Submit</button>
          </form>

        );

      case 3:
        return (
          <form onSubmit={handleDetail}  >
            <div className='main-payment '>
              <div className="wallet-confirmation">
                <div className="wallet-card">
                  <div className="checkmark-circle">
                    <i className="fa-solid fa-check"></i>
                  </div>
                  <h3>Recharge your Wallet</h3>
                  <div className='top-heading' >
                      {response && <p className='fw-bold'>{response}</p>
              }
                  </div>
                  
                  <p className="wallet-subtext">Your top up has been completed</p>

                  <div className="topup-info">
                    <label>Total Top Up</label>
                    <div >₹ <input className="topup-amount" placeholder='7500.00' name='amount' value={tnxData.amount} onChange={handleTnxChange} required/></div>
                  </div>



                  <div className="tips-section">
                    <div className="payment-method">
                      <label htmlFor="payment-method-select">Payment Mode To:</label>
                      <select
                        id="payment-method-select"
                        required
                        name="mode"
                        value={tnxData.mode}
                        onChange={handleTnxChange}
                      >
                        <option value="">-- Select --</option>
                        <option value="qr">QR</option>
                        <option value="bank">Bank Transfer</option>
                        <option value="upi">UPI</option>
                        <option value="cash">Cash</option>
                      </select>
                    </div>

                    <input
                      type="text"
                      name="tranx"
                      value={tnxData.tranx}
                      onChange={handleTnxChange}
                      placeholder="Enter Transaction ID*"
                      required
                    />

                    <div className="upload-proof">
                      <label htmlFor="payment-proof">Upload Payment Screenshot</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <input
                        type="file"
                        id="payment-proof"
                        accept="image/*,application/pdf"
                        name="file"
                        onChange={handleTnxChange}
                        required={tnxData.mode !== "cash"}
                        style={{ padding: '0rem', marginTop: "0rem", marginBottom: "0rem" }}

                      />
                    </div>
                    <br />
                    <button type='submit' className="create-account-btn">Recharge & Verify</button>


            <div className="mobile-only">
              <br />
              <h3>Secure Recharge</h3>
              <p>Complete your wallet top-up to continue.</p>

              <div style={{display: 'block', backgroundColor: 'whitesmoke', borderRadius: '10px', padding: '10px'}}>
                <div>
                  <h4>Canara Bank A/C Details:</h4>
                  <p><strong>Account Holder:</strong> DULEHRA CHAUHAN</p>
                  <p><strong>Account Number:</strong> 60505595984</p>
                  <p><strong>IFSC Code:</strong> MAHB0001755</p>
                </div>
                <div className="qr-section1" style={{textAlign: 'center'}}>
                  <img src={QRimg} alt="QR Code" style={{height: '18em', margin: 'auto'}} />
                  <p>Scan to pay</p>
                </div>
              </div>

              <div className="tips-section">
                <h4>Important: Payment Process</h4>
                <ul>
                  <li><i className="fa-solid fa-circle-check"></i> Make Payment of 7500 to Recharge your wallet.</li>
                  <li><i className="fa-solid fa-circle-check"></i>  After payment is done to any of the modes mentioned above i.e. Bank Account, UPI, QR Code, upload the Payment Screenshot, Transaction ID/ No, & Select Payment Mode To.</li>
                  <li><i className="fa-solid fa-circle-check"></i> Click on Recharged & Verify. Wait for Payment Verification, it might take upto 24 hours. Once the payment is verified, the recharge amount will reflect in your wallet.</li>
                </ul>
              </div>
            </div>

                  </div>
                  
                </div>
              </div>
            </div>
          </form>

        );
      case 4:
        return (
          <>
            <div className="processing-step">
              <div className="loader-circle"></div>
              <h2>We're processing your KYC</h2>
              <p className="processing-text">The payment is currently being processed and will be finalized within the next 24 hours. Thank you for your patience. Login to your Account on our App & explore.</p>
            </div>
            <Link to='/'><button type="button" className="create-account-btn">Download App</button></Link>
          </>
        );

      default:
        return null;
    }
  };

  const getImage = () => {
    if (step === 1) return image2;
    if (step === 2) return img1;
    if (step === 4) return img2;
    if (step === 3) return img2;
    // return null;
  };

  const getQuote = () => {
    if (step === 1) return {
      name: "Ruchi",
      quote: "“I've Mastered the art of Chain Marketing. Big Fresh Mart really the best MLM platform to work with. Work & Earn!”"
    };
    if (step === 2) return {
      name: "Sneha Sharma",
      quote: "“Big Fresh Mart made grocery shopping so easy and reliable. Highly recommended!”"
    };
    if (step === 4) return {
      name: "Rohit Patel",
      quote: "“Everything from packaging to delivery is perfect. Fresh and affordable!”"
    };
    return '';
  };

  const quote = getQuote();

  return (
    <div className="signup-wrapper">
      <div className="doodle-group-left">
        <img src={dimg3} alt="left doodle 3" />
        <img src={dimg1} alt="left doodle 1" />
        <img src={dimg2} alt="left doodle 2" />
      </div>
      <div className="doodle-group-right">
        <img src={dimg4} alt="right doodle 1" />
        <img src={dimg5} alt="right doodle 2" />
        <img src={dimg1} alt="right doodle 3" />
      </div>

      <div className="signup-container">
        <div className="signup-form">
          <h2>Big Fresh Mart</h2>

          <div className="step-indicator">
            <div className={`step-dot ${step >= 1 ? 'completed' : ''} ${step === 1 ? 'active' : ''}`}></div>
            <div className={`step-dot ${step >= 2 ? 'completed' : ''} ${step === 2 ? 'active' : ''}`}></div>
            <div className={`step-dot ${step >= 3 ? 'completed' : ''} ${step === 3 ? 'active' : ''}`}></div>
            <div className={`step-dot ${step === 4 ? 'completed' : ''} ${step === 4 ? 'active' : ''}`}></div>
          </div>

          {/* <form> */}
          {renderForm()}
          {/* {step === 1 && <p className="login-link">Already Have An Account? <span>Login</span></p>} */}

          {/* </form> */}
        </div>

        {/* Right section: image or custom component */}
        {step !== 3 ? (
          <div className="signup-image" style={{ backgroundImage: `url(${getImage()})` }}>
            <div className="image-overlay">
              <div className="testimonial">
                <h4>{quote.name}</h4>
                <p>{quote.quote}</p>
                <div className="dot-nav">
                  <span className={`dot ${step === 1 ? 'active' : ''}`}></span>
                  <span className={`dot ${step === 2 ? 'active' : ''}`}></span>
                  <span className={`dot ${step === 3 ? 'active' : ''}`}></span>
                  <span className={`dot ${step === 4 ? 'active' : ''}`}></span>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="signup-right-component1">
            <div className="payment-info-box1">
              <h3>Secure Recharge</h3>
              <p>Complete your wallet top-up to continue.</p>

              <div className='hello1 '>
                <div className="bank-details1">
                  <h4>Canara Bank A/C Details:</h4>
                  <p><strong>Account Holder:</strong> DULEHRA CHAUHAN</p>
                  <p><strong>Account Number:</strong> 60505595984</p>
                  <p><strong>IFSC Code:</strong> MAHB0001755</p>
                </div>
                <div className="qr-section1">
                  <img src={QRimg} alt="QR Code" className="qr-image1" />
                  <p>Scan to pay</p>
                </div>
              </div>

              <div className="tips-section">
                <h4>Important: Payment Process</h4>
                <ul>
                  <li><i className="fa-solid fa-circle-check"></i> Make Payment of 7500 to Recharge your wallet.</li>
                  <li><i className="fa-solid fa-circle-check"></i>  After payment is done to any of the modes mentioned above i.e. Bank Account, UPI, QR Code, upload the Payment Screenshot, Transaction ID/ No, & Select Payment Mode To.</li>
                  <li><i className="fa-solid fa-circle-check"></i> Click on Recharged & Verify. Wait for Payment Verification, it might take upto 24 hours. Once the payment is verified, the recharge amount will reflect in your wallet.</li>
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>
          <ToastContainer />
    </div>
  );
};


export default Register;
